import { EntityType } from '@frontend/common';
import { UserGroupClient } from '@frontend/group/api';
import { useResolver } from '@frontend/repository';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import React from 'react';

declare global {
    interface WindowEventMap {
        'useUserGroup:request': CustomEvent<string>;
    }
}

const REQUEST_USER_GROUP_EVENT = 'useUserGroup:request';
const STORAGE_KEY = 'USER_GRP_REQ';

export function userGroupRequest(groupId: string): string {
    window.dispatchEvent(new CustomEvent(REQUEST_USER_GROUP_EVENT, { detail: groupId }));
    return STORAGE_KEY + '_loading';
}

interface Props {
    dispatch: ThunkDispatch<any, any, Action>;
}

export function UserGroupResolver(props: Props) {
    useResolver(STORAGE_KEY, REQUEST_USER_GROUP_EVENT, EntityType.USER_GROUP, (ids) => UserGroupClient.resolveUserGroups(ids), props.dispatch);
    return <></>;
}
